var _defs, _g, _text;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotificationOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 75 75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        letter-spacing: -.03em;\n      }\n\n      .cls-2 {\n        font-family: Roobert-Medium, Roobert;\n        font-size: 9px;\n        font-weight: 500;\n      }\n\n      .cls-3 {\n        fill: none;\n        stroke: #000;\n        stroke-miterlimit: 10;\n        stroke-width: 3px;\n      }\n\n      .cls-4 {\n        letter-spacing: -.01em;\n      }\n\n      .cls-5 {\n        letter-spacing: 0em;\n      }\n\n      .cls-6 {\n        letter-spacing: 0em;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m28.5,56.37c0,4.97,4.03,9,9,9s9-4.03,9-9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m17.66,56.37h39.68c2.3,0,3.75-2.22,2.61-4l-2.87-4.5c-.43-.67-.65-1.43-.65-2.21v-18.77c0-9.15-7.98-16.94-18.23-17.27-10.76-.34-19.61,7.34-19.61,16.86v19.17c0,.77-.23,1.53-.65,2.21l-2.87,4.5c-1.14,1.78.31,4,2.61,4Z"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(1.25 -5.87)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-6",
    x: 0,
    y: 0
  }, "N"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-4",
    x: 6.38,
    y: 0
  }, "o"), /*#__PURE__*/React.createElement("tspan", {
    x: 11.63,
    y: 0
  }, "tific"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-5",
    x: 27.51,
    y: 0
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    x: 32.35,
    y: 0
  }, "tion - Of"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-1",
    x: 63.87,
    y: 0
  }, "f"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationOff);
export default __webpack_public_path__ + "static/media/__Notification - Off.e4a43f7bda326cc1aa32d93917feb5d1.svg";
export { ForwardRef as ReactComponent };